import React from 'react';
import { SectionWrapper } from './ui';
import { StarIcon, ShieldCheckIcon } from 'lucide-react';
const TestimonialCard = ({
  name,
  location,
  role,
  text
}: {
  name: string;
  location: string;
  role?: string;
  text: string;
}) => <div className="bg-dark-card border border-dark-border rounded-2xl p-6 shadow-lg hover:border-primary/40 transition-colors" data-id="element-289">
    <div className="flex text-accent mb-4" data-id="element-290">
      {[...Array(5)].map((_, i) => <StarIcon key={i} size={18} fill="currentColor" data-id="element-291" />)}
    </div>
    <p className="text-cyan-50/90 italic mb-6 leading-relaxed" data-id="element-292">"{text}"</p>
    <div data-id="element-293">
      <p className="text-white font-bold" data-id="element-294">{name}</p>
      <p className="text-sm text-cyan-200/60" data-id="element-295">
        📍 {location} {role && `· ${role}`}
      </p>
    </div>
  </div>;
export const TestimonialsSet1 = () => {
  const testimonials = [{
    name: 'Sebastián M.',
    location: 'Buenos Aires',
    text: 'Antes tardaba 2 horas en redactar una propuesta. Ahora la IA me la genera en 8 minutos. Cerré 3 clientes más este mes sin trabajar más horas.'
  }, {
    name: 'Lorena P.',
    location: 'Córdoba',
    text: 'Subí mis tarifas un 35% en 45 días. Mis clientes no se fueron. Se quedaron todos porque ahora entrego propuestas, análisis y reportes que antes no podía ni imaginar.'
  }];
  return <SectionWrapper className="bg-dark-bg" data-id="element-296">
      <div className="grid md:grid-cols-2 gap-6 max-w-4xl mx-auto" data-id="element-297">
        {testimonials.map((t, i) => <TestimonialCard key={i} {...t} data-id="element-298" />)}
      </div>
    </SectionWrapper>;
};
export const TestimonialsSet2 = () => {
  const testimonials = [{
    name: 'Rodrigo V.',
    location: 'Buenos Aires',
    text: 'Cerré una propuesta de $450.000 con el sistema del Tomo 5. El cliente me dijo que fue la propuesta más profesional que recibió. La armé en 12 minutos con la IA.'
  }, {
    name: 'Marta C.',
    location: 'Rosario',
    text: 'Antes me llevaba 3 horas preparar el contenido de la semana. Ahora con el Tomo 3 genero todo el mes en una tarde. Mis redes crecieron un 60% en 45 días.'
  }, {
    name: 'Damián R.',
    location: 'Córdoba',
    text: 'El Tablero de Decisión del Tomo 4 me mostró que mi cliente más grande era el menos rentable. Sin el SUPERKIT IA nunca lo hubiera descubierto. Renegoció el contrato y subí el margen un 19%.'
  }, {
    name: 'Valeria S.',
    location: 'Mendoza',
    text: 'Usé el Plan de 7 Días del Bono 6 para implementar todo gradualmente. Para el día 4 ya estaba usando IA para organizar mi jornada. Para el día 7 tenía un sistema que funciona solo.'
  }, {
    name: 'Federico L.',
    location: 'La Plata',
    text: 'Respondí 15 mails difíciles en 20 minutos con el Banco de Prompts del Bono 3. Antes me llevaban toda la tarde. Ese solo bono ya justificó la compra.'
  }];
  return <SectionWrapper className="bg-dark-bg" data-id="element-299">
      <div className="text-center mb-12" data-id="element-300">
        <h2 className="text-3xl md:text-5xl font-black text-white mb-4" data-id="element-301">
          ❤️ MÁS PROFESIONALES QUE YA LO TIENEN
        </h2>
      </div>
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto" data-id="element-302">
        {testimonials.map((t, i) => <TestimonialCard key={i} {...t} data-id="element-303" />)}
      </div>
    </SectionWrapper>;
};
export const Guarantee = () => {
  return <SectionWrapper className="bg-dark-card/50 border-y border-dark-border" data-id="element-304">
      <div className="max-w-3xl mx-auto text-center" data-id="element-305">
        <div className="inline-flex items-center justify-center w-20 h-20 bg-primary/10 text-primary rounded-full mb-8 ring-1 ring-primary/30" data-id="element-306">
          <ShieldCheckIcon size={40} data-id="element-307" />
        </div>
        <h2 className="text-3xl md:text-5xl font-black text-white mb-6" data-id="element-308">
          GARANTÍA 7 DÍAS — SIN PREGUNTAS
        </h2>
        <p className="text-xl text-cyan-50/90 mb-4" data-id="element-309">
          Abrís los tomos. Los usás en tu trabajo real esta semana.
        </p>
        <p className="text-2xl font-bold text-white" data-id="element-310">
          Si en 7 días no es lo que esperabas: <br data-id="element-311" />
          <span className="text-primary" data-id="element-312">devolución del 100%</span> <br data-id="element-313" />
          <span className="text-cyan-200/70 text-lg font-normal" data-id="element-314">
            sin formularios, sin drama, sin preguntas incómodas.
          </span>
        </p>
      </div>
    </SectionWrapper>;
};